import { Bar } from 'react-chartjs-2';
import { Card } from '@mui/material';
import { subTitleFont, titleColor, titleFont, titlePadding } from './charts-data-config';

export default function ChartVerticalBar({ chartData }: any) {
  return (
    <Card sx={{ width: 350, height: 350 }}>
      <Bar
        height={350}
        data={{
          labels: chartData.labels,
          datasets: [
            {
              label: chartData.label,
              data: chartData.data,
              backgroundColor: `rgb(${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)})`,
            },
          ]
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true
            }
          },
          plugins: {
            subtitle: {
              display: chartData.displaySubtitle,
              text: chartData.subtitle,
              font: subTitleFont,
            },
            title: {
              display: chartData.displayTitle,
              text: chartData.title,
              font: titleFont,
              color: titleColor,
              padding: titlePadding
            }
          }
        }}
      />
    </Card>
  );
}
